export const dataSpecificJsonData = {
  type: 'string',
};

export const nullableDataSpecificJsonData = {
  type: [dataSpecificJsonData.type, 'null'],
};
